export type PagedQueryParams = {
  q?: string;
  take?: number;
  skip?: number;
  orderBy?: string;
  orderDir?: "asc" | "desc";
  [key: string]: unknown;
};

export type PagedResponse<T> = {
  data: T[];
  total: number;
};

export const buildQuery = (params: PagedQueryParams) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }
    search.set(key, String(value));
  });
  return search.toString();
};

export const parsePagedResponse = <T,>(payload: unknown): PagedResponse<T> => {
  if (Array.isArray(payload)) {
    return { data: payload as T[], total: payload.length };
  }
  if (!payload || typeof payload !== "object") {
    return { data: [], total: 0 };
  }
  const typed = payload as { data?: unknown; total?: unknown };
  if (Array.isArray(typed.data)) {
    return {
      data: typed.data as T[],
      total: typeof typed.total === "number" ? typed.total : typed.data.length,
    };
  }
  return { data: [], total: 0 };
};
